import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import About from './pages/About';
import Team from './pages/Team';
import Publications from './pages/Publications';
import Contact from './pages/Contact';
import LaborExpert from './pages/LaborExpert';
import translations from './translations';
import StructuredData from './components/StructuredData';
import ScrollToTop from './components/ScrollToTop';

function App() {
  const [darkMode, setDarkMode] = useState(false);
  const [language, setLanguage] = useState('tr');
  const [menuOpen, setMenuOpen] = useState(false);
  const t = translations[language];

  return (
    <Router>
      <StructuredData />
      <ScrollToTop />
      <div className={`App ${darkMode ? 'dark-mode' : 'light-mode'} lang-${language}`}>
        <nav className="navbar">
          <div className="nav-container">
            <Link to="/" className="logo" onClick={() => setMenuOpen(false)}>
              <img src={`${process.env.PUBLIC_URL}/favicon.svg`} alt="" className="logo-icon" />
              TAMA & ORAL
            </Link>

            <button
              className="hamburger-menu"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>

            <div className={`nav-menu ${menuOpen ? 'active' : ''}`}>
              <Link to="/" className="nav-link" onClick={() => setMenuOpen(false)}>{t.home}</Link>
              <Link to="/about" className="nav-link" onClick={() => setMenuOpen(false)}>{t.about}</Link>
              <Link to="/team" className="nav-link" onClick={() => setMenuOpen(false)}>{t.team}</Link>
              <Link to="/publications" className="nav-link" onClick={() => setMenuOpen(false)}>{t.publications}</Link>
              <Link to="/contact" className="nav-link" onClick={() => setMenuOpen(false)}>{t.contact}</Link>
            </div>

            <div className="nav-controls">
              <div className="language-switcher">
                <button
                  className={`lang-btn ${language === 'tr' ? 'active' : ''}`}
                  onClick={() => setLanguage('tr')}
                  title="Türkçe"
                >
                  TR
                </button>
                <button
                  className={`lang-btn ${language === 'en' ? 'active' : ''}`}
                  onClick={() => setLanguage('en')}
                  title="English"
                >
                  EN
                </button>
                <button
                  className={`lang-btn ${language === 'ar' ? 'active' : ''}`}
                  onClick={() => setLanguage('ar')}
                  title="العربية"
                >
                  AR
                </button>
              </div>

              <button
                className="theme-toggle"
                onClick={() => setDarkMode(!darkMode)}
                title={darkMode ? 'Light Mode' : 'Dark Mode'}
              >
                {darkMode ? '☀️' : '🌙'}
              </button>
            </div>
          </div>
        </nav>

        <Routes>
          <Route path="/" element={<Home language={language} t={t} />} />
          <Route path="/about" element={<About language={language} t={t} />} />
          <Route path="/team" element={<Team language={language} t={t} />} />
          <Route path="/publications" element={<Publications language={language} t={t} />} />
          <Route path="/contact" element={<Contact language={language} t={t} />} />
          <Route path="/is-hukuku-bilirkisi" element={<LaborExpert />} />
        </Routes>

        <a
          href="https://wa.me/905379371064"
          className="whatsapp-float"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="WhatsApp"
          title="WhatsApp"
        >
          <svg viewBox="0 0 32 32" width="34" height="34" aria-hidden="true" fill="currentColor">
            <path d="M16.004 3C8.832 3 3 8.832 3 16.004c0 2.29.6 4.52 1.74 6.49L3 29l6.68-1.72a12.94 12.94 0 0 0 6.32 1.62h.005C23.173 28.9 29 23.068 29 15.896 29 8.724 23.176 3 16.004 3zm0 23.68a10.7 10.7 0 0 1-5.46-1.49l-.39-.23-3.96 1.02 1.06-3.86-.25-.4a10.7 10.7 0 0 1-1.64-5.72c0-5.9 4.8-10.7 10.71-10.7 5.9 0 10.7 4.8 10.7 10.7 0 5.9-4.8 10.68-10.77 10.68zm5.87-8c-.32-.16-1.9-.94-2.2-1.04-.29-.11-.5-.16-.71.16-.21.32-.81 1.04-.99 1.25-.18.21-.37.24-.69.08-.32-.16-1.35-.5-2.57-1.59-.95-.85-1.6-1.9-1.78-2.22-.19-.32-.02-.49.14-.65.14-.14.32-.37.48-.56.16-.19.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.71-1.71-.97-2.34-.26-.62-.52-.53-.71-.54h-.61c-.21 0-.56.08-.85.4-.29.32-1.11 1.09-1.11 2.65 0 1.57 1.14 3.08 1.3 3.29.16.21 2.24 3.42 5.43 4.8.76.33 1.35.52 1.81.67.76.24 1.45.21 2 .13.61-.09 1.9-.78 2.16-1.53.27-.75.27-1.39.19-1.53-.08-.13-.29-.21-.61-.37z"/>
          </svg>
        </a>

        <footer className="footer">
          <div className="footer-content">
            <div className="footer-section">
              <h4>TAMA & ORAL {language === 'tr' ? 'Hukuk Bürosu' : language === 'en' ? 'Law Office' : 'مكتب قانوني'}</h4>
              <p>{t.legalServices}</p>
            </div>
            <div className="footer-section">
              <h4>{t.socialMedia}</h4>
              <a href="https://x.com/tamaoralavtr" target="_blank" rel="noopener noreferrer">X</a>
              <a href="https://instagram.com/tamaoralavtr" target="_blank" rel="noopener noreferrer">Instagram</a>
            </div>
            <div className="footer-section">
              <h4>{t.legal}</h4>
              <a href="#privacy">{t.privacy}</a>
              <a href="#terms">{t.terms}</a>
            </div>
          </div>
          <div className="footer-bottom">
            <p>{t.copyright}</p>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
